import type { IBounds } from "./Bounds.interface";
import type { IStudioOverlayCustom } from "./Overlay.interface";

export enum MaskType {
  external = "external",
  composition = "composition",
}

/** Máscara/chrome legacy: un único asset externo (imagen o video) full-canvas. */
export type MaskExternal = {
  type: MaskType.external;
  src: string;
  bounds: Omit<IBounds, "zIndex">;
};

/**
 * Máscara como composición de overlay a nivel-escena (full-canvas, SIN área
 * portadora). Reusa el formato de overlay (`IStudioOverlayCustom`: elements,
 * designAspectRatio, variables, pollingConfig) y se renderiza/edita con el
 * mismo pipeline que `area.overlay`. NO soporta `sourceSlot`: un overlay
 * full-scene no tiene una sola fuente para encastrar/clippear.
 */
export type MaskComposition = {
  type: MaskType.composition;
  overlay: IStudioOverlayCustom;
  /** % del lienzo (0..100). Default 0/0/100/100 (todo el lienzo). */
  bounds?: Omit<IBounds, "zIndex">;
  /** Banda de stacking del chrome en la escena. Default = MASK_BASE_Z. */
  zIndex?: number;
};

export type IStudioMask = MaskExternal | MaskComposition;
